import { ORDER_INQUIRY_ERROR_CODES, type OrderInquiryErrorCode } from '@repo/api-contracts';

const MESSAGES: Readonly<Record<OrderInquiryErrorCode, string>> = {
  NOT_FOUND: '문의를 찾을 수 없어요.',
  ORDER_NOT_ELIGIBLE: '결제가 완료된 주문에만 문의를 남길 수 있어요.',
  NOT_STARTED: '제작 착수 전에는 취소 요청을 이용해 주세요.',
  ALREADY_OPEN: '처리 중인 문의가 있어요. 답변 뒤에 다시 접수할 수 있어요.',
  INVALID_IMAGE: '사용할 수 없는 사진이 있어요. 사진을 다시 올려 주세요.',
  CONFLICT: '문의가 바뀌었어요. 새로 불러온 뒤 다시 시도해 주세요.',
};
const FALLBACK = '문의를 보내지 못했어요. 잠시 후 다시 시도해 주세요.';

const isOrderInquiryErrorCode = (value: unknown): value is OrderInquiryErrorCode =>
  typeof value === 'string' && (ORDER_INQUIRY_ERROR_CODES as readonly string[]).includes(value);

export const orderInquiryErrorMessage = (error: unknown): string => {
  if (typeof error !== 'object' || error === null || !('data' in error)) return FALLBACK;
  const data = (error as { data: unknown }).data;
  const code =
    typeof data === 'object' && data !== null && 'orderInquiryErrorCode' in data
      ? (data as { orderInquiryErrorCode: unknown }).orderInquiryErrorCode
      : null;
  return isOrderInquiryErrorCode(code) ? MESSAGES[code] : FALLBACK;
};
